var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import Vue from 'vue';
import projectApiClient from '@/plugins/apis/project-api-client';
import projectUserApiClient from '@/plugins/apis/project-user-api-client';
import { ProjectMutationTypes, ProjectStatus } from '@/types/project';
var CancelToken = axios.CancelToken;
/** サイドバー project-list の1回あたりの取得件数 */
var LIST_PROJECTS_PAGE_SIZE = 25;
/** project-list 用: フィルタ「すべて」のときの API status（waiting, working） */
var LIST_PROJECTS_STATUS_ALL = [ProjectStatus.waiting, ProjectStatus.working];
/** フィルタ値を API の status パラメータに変換 */
function listFilterStatusToApiStatus(filter) {
    switch (filter) {
        case 'all':
            return LIST_PROJECTS_STATUS_ALL;
        case ProjectStatus.working:
            return ProjectStatus.working;
        case ProjectStatus.waiting:
            return ProjectStatus.waiting;
        default:
            return LIST_PROJECTS_STATUS_ALL;
    }
}
/** UI のソート選択値を API 用の sort に変換 */
function projectListSortKeyToApiSort(key) {
    switch (key) {
        case 'created_desc':
            return { target: 'created_at', order: 'desc' };
        case 'created_asc':
            return { target: 'created_at', order: 'asc' };
        case 'updated_desc':
            return { target: 'updated_at', order: 'desc' };
        case 'updated_asc':
            return { target: 'updated_at', order: 'asc' };
        default:
            return { target: 'created_at', order: 'desc' };
    }
}
export var state = function () { return ({
    projects: [],
    project: {
        id: '',
        title: '',
        customer_id: '',
        content_id: '',
        construction_kinds: [],
        status: ProjectStatus.waiting,
        cover_image: '',
        cover_image_name: '',
        saturday_off: false,
        sunday_off: false,
        monday_off: false,
        tuesday_off: false,
        wednesday_off: false,
        thursday_off: false,
        friday_off: false,
        holiday_off: false,
        invitation_link_expires_in: '',
        invitation_link: '',
        invitation_link_expired: true,
        users: [],
        customer: {
            id: '',
            name: '',
            content_id: '',
            policies: {
                destroy: false,
                show: false,
                update: false
            }
        },
        policies: {
            update: false,
            destroy: false,
            show: false,
            invite_members: false
        }
    },
    paginate: {
        current_limit: 0,
        current_offset: 0,
        total_count: 0
    },
    listProjects: [],
    listPaginate: {
        current_limit: 0,
        current_offset: 0,
        total_count: 0
    },
    currentSort: 'created_desc',
    listBookmarkedOnly: false,
    listFilterStatus: 'all',
    places: {
        convenience_store: [],
        parking: [],
        home_center: []
    },
    bookmarks: [],
    hierarchyYearSummary: null,
    hierarchyMonthCache: {},
    hierarchyProjectCache: {},
    hierarchyPaginateCache: {},
    hierarchyUnscheduledCount: null,
    hierarchyTotalCount: null,
    hierarchyUnscheduledProjects: [],
    hierarchyUnscheduledPaginate: null
}); };
export var getters = {
    projects: function (state) {
        if (!state.projects.length) {
            return state.projects;
        }
        return JSON.parse(JSON.stringify(state.projects));
    },
    project: function (state) {
        return state.project;
    },
    paginate: function (state) {
        return state.paginate;
    },
    listProjects: function (state) {
        if (!state.listProjects.length) {
            return state.listProjects;
        }
        return JSON.parse(JSON.stringify(state.listProjects));
    },
    listPaginate: function (state) {
        return state.listPaginate;
    },
    currentSort: function (state) {
        return state.currentSort;
    },
    mapAddress: function (state) {
        return state.project.prefecture_name + state.project.city;
    },
    places: function (state) {
        var dumpPlaces = JSON.parse(JSON.stringify(state.places));
        for (var key in dumpPlaces) {
            dumpPlaces[key].sort(function (a, b) {
                return a.distance - b.distance;
            });
        }
        return dumpPlaces;
    },
    bookmarks: function (state) {
        return state.bookmarks;
    },
    isProjectBookmarked: function (state) { return function (projectId) {
        return state.bookmarks.some(function (b) { return b.project_id === projectId; });
    }; },
    hierarchyYearSummary: function (state) {
        return state.hierarchyYearSummary || [];
    },
    hierarchyMonthSummary: function (state) { return function (year) {
        return state.hierarchyMonthCache[year] || null;
    }; },
    hierarchyProjects: function (state) { return function (year, month) {
        var key = year + "-" + month;
        return state.hierarchyProjectCache[key] || null;
    }; },
    hierarchyProjectsPaginate: function (state) { return function (year, month) {
        var key = year + "-" + month;
        return state.hierarchyPaginateCache[key] || null;
    }; },
    hierarchyUnscheduledCount: function (state) {
        var _a;
        return (_a = state.hierarchyUnscheduledCount) !== null && _a !== void 0 ? _a : 0;
    },
    hierarchyTotalCount: function (state) {
        return state.hierarchyTotalCount;
    },
    hierarchyUnscheduledProjects: function (state) {
        return state.hierarchyUnscheduledProjects || [];
    },
    hierarchyUnscheduledPaginate: function (state) {
        var _a;
        return (_a = state.hierarchyUnscheduledPaginate) !== null && _a !== void 0 ? _a : null;
    }
};
export var mutations = (_a = {},
    _a[ProjectMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[ProjectMutationTypes.SET_PROJECTS_SORT] = function (state, payload) {
        state.currentSort = payload;
    },
    _a[ProjectMutationTypes.SET_LIST_BOOKMARKED_ONLY] = function (state, payload) {
        state.listBookmarkedOnly = payload;
    },
    _a[ProjectMutationTypes.SET_LIST_FILTER_STATUS] = function (state, payload) {
        state.listFilterStatus = payload;
    },
    _a[ProjectMutationTypes.INIT_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        state.projects = projects;
        state.paginate = paginate;
    },
    _a[ProjectMutationTypes.FETCH_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        var ids = state.projects.map(function (c) { return c.id; });
        var filteredList = projects.filter(function (c) {
            return !ids.includes(c.id);
        });
        state.projects = state.projects.concat(filteredList);
        state.paginate = paginate;
    },
    _a[ProjectMutationTypes.INIT_LIST_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        state.listProjects = projects;
        state.listPaginate = paginate;
    },
    _a[ProjectMutationTypes.FETCH_LIST_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        var ids = state.listProjects.map(function (c) { return c.id; });
        var filteredList = projects.filter(function (c) { return !ids.includes(c.id); });
        state.listProjects = state.listProjects.concat(filteredList);
        state.listPaginate = paginate;
    },
    _a[ProjectMutationTypes.FETCH_PROJECT] = function (state, payload) {
        state.project = payload;
    },
    _a[ProjectMutationTypes.ADD_PROJECT] = function (state, project) {
        state.projects.unshift(project);
        state.paginate.total_count += 1;
        // project-list 用: waiting/working なら一覧にも追加
        if (project.status === ProjectStatus.waiting || project.status === ProjectStatus.working) {
            state.listProjects.unshift(project);
            state.listPaginate.total_count += 1;
        }
    },
    _a[ProjectMutationTypes.UPDATE_PROJECT_IN_LIST] = function (state, updatedProject) {
        var index = state.projects.findIndex(function (p) { return p.id === updatedProject.id; });
        if (index !== -1) {
            Vue.set(state.projects, index, updatedProject);
        }
        // project-list 用: 一覧に含まれていれば更新、completed/archived なら削除
        var listIdx = state.listProjects.findIndex(function (p) { return p.id === updatedProject.id; });
        if (listIdx !== -1) {
            if (updatedProject.status === ProjectStatus.completed ||
                updatedProject.status === ProjectStatus.archived) {
                state.listProjects.splice(listIdx, 1);
                state.listPaginate.total_count = Math.max(0, state.listPaginate.total_count - 1);
            }
            else {
                Vue.set(state.listProjects, listIdx, updatedProject);
            }
        }
        // 階層表示用のキャッシュも更新
        Object.keys(state.hierarchyProjectCache).forEach(function (key) {
            var projects = state.hierarchyProjectCache[key];
            var idx = projects.findIndex(function (p) { return p.id === updatedProject.id; });
            if (idx !== -1) {
                Vue.set(projects, idx, updatedProject);
            }
        });
    },
    _a[ProjectMutationTypes.DELETE_PROJECT] = function (state, payload) {
        var index = state.projects.findIndex(function (p) { return p.id === payload; });
        if (index !== -1) {
            Vue.delete(state.projects, index);
        }
        var listIdx = state.listProjects.findIndex(function (p) { return p.id === payload; });
        if (listIdx !== -1) {
            state.listProjects.splice(listIdx, 1);
            state.listPaginate.total_count = Math.max(0, state.listPaginate.total_count - 1);
        }
    },
    _a[ProjectMutationTypes.FETCH_PLACES] = function (state, payload) {
        state.places = payload;
    },
    _a[ProjectMutationTypes.CLEAR_PLACES] = function (state) {
        state.places.convenience_store = [];
        state.places.parking = [];
        state.places.home_center = [];
    },
    _a[ProjectMutationTypes.CREATE_INVITATION_LINK] = function (state, payload) {
        state.project.invitation_link = payload.invitation_link;
        state.project.invitation_link_expires_in = payload.invitation_link_expires_in;
        state.project.invitation_link_expired = false;
    },
    _a[ProjectMutationTypes.DELETE_INVITATION_LINK] = function (state) {
        state.project.invitation_link = '';
        state.project.invitation_link_expires_in = '';
        state.project.invitation_link_expired = true;
    },
    _a[ProjectMutationTypes.CHANGE_STATUS] = function (state, payload) {
        var index = state.projects.findIndex(function (p) { return p.id === payload.id; });
        if (index !== -1) {
            state.projects[index].status = payload.status;
        }
        var listIdx = state.listProjects.findIndex(function (p) { return p.id === payload.id; });
        if (listIdx !== -1) {
            if (payload.status === ProjectStatus.completed || payload.status === ProjectStatus.archived) {
                state.listProjects.splice(listIdx, 1);
                state.listPaginate.total_count = Math.max(0, state.listPaginate.total_count - 1);
            }
            else {
                state.listProjects[listIdx].status = payload.status;
            }
        }
    },
    _a[ProjectMutationTypes.FETCH_BOOKMARKS] = function (state, payload) {
        state.bookmarks = payload;
    },
    _a[ProjectMutationTypes.SORT_BOOKMARKS] = function (state, payload) {
        var _a, _b;
        var projectId = 'project_id' in payload
            ? payload.project_id
            : (_b = (_a = payload.project) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
        var record = { id: payload.id, project_id: projectId, sort_num: payload.sort_num };
        var target_index = state.bookmarks.findIndex(function (bookmark) { return record.id === bookmark.id; });
        if (target_index === -1)
            return;
        state.bookmarks.splice(target_index, 1);
        state.bookmarks.splice(record.sort_num - 1, 0, record);
        state.bookmarks.forEach(function (bookmark, index) {
            bookmark.sort_num = index + 1;
        });
    },
    _a[ProjectMutationTypes.SET_HIERARCHY_YEAR_SUMMARY] = function (state, payload) {
        if (Array.isArray(payload)) {
            state.hierarchyYearSummary = payload;
        }
        else {
            state.hierarchyYearSummary = payload.summary;
            state.hierarchyTotalCount = payload.meta.total_count;
            state.hierarchyUnscheduledCount = payload.meta.unscheduled_count;
        }
    },
    _a[ProjectMutationTypes.SET_HIERARCHY_MONTH_SUMMARY] = function (state, _a) {
        var year = _a.year, summary = _a.summary;
        Vue.set(state.hierarchyMonthCache, year, summary);
    },
    _a[ProjectMutationTypes.SET_HIERARCHY_PROJECTS] = function (state, _a) {
        var year = _a.year, month = _a.month, projects = _a.projects, paginate = _a.paginate;
        var key = year + "-" + month;
        Vue.set(state.hierarchyProjectCache, key, projects);
        Vue.set(state.hierarchyPaginateCache, key, paginate);
    },
    _a[ProjectMutationTypes.APPEND_HIERARCHY_PROJECTS] = function (state, _a) {
        var year = _a.year, month = _a.month, projects = _a.projects, paginate = _a.paginate;
        var key = year + "-" + month;
        var existing = state.hierarchyProjectCache[key] || [];
        Vue.set(state.hierarchyProjectCache, key, existing.concat(projects));
        Vue.set(state.hierarchyPaginateCache, key, paginate);
    },
    _a[ProjectMutationTypes.SET_HIERARCHY_UNSCHEDULED_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        state.hierarchyUnscheduledProjects = projects;
        state.hierarchyUnscheduledPaginate = paginate;
    },
    _a[ProjectMutationTypes.APPEND_HIERARCHY_UNSCHEDULED_PROJECTS] = function (state, _a) {
        var projects = _a.projects, paginate = _a.paginate;
        state.hierarchyUnscheduledProjects = state.hierarchyUnscheduledProjects.concat(projects);
        state.hierarchyUnscheduledPaginate = paginate;
    },
    _a[ProjectMutationTypes.CLEAR_HIERARCHY_CACHE] = function (state) {
        state.hierarchyYearSummary = null;
        state.hierarchyMonthCache = {};
        state.hierarchyProjectCache = {};
        state.hierarchyPaginateCache = {};
        state.hierarchyUnscheduledCount = null;
        state.hierarchyTotalCount = null;
        state.hierarchyUnscheduledProjects = [];
        state.hierarchyUnscheduledPaginate = null;
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(ProjectMutationTypes.INIT_STATE, state());
    },
    setSortAndInitProjects: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        commit(ProjectMutationTypes.SET_PROJECTS_SORT, payload);
        return dispatch('initListProjects');
    },
    initProjects: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var params, res, _b, projects, paginate;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        params = { offset: 0 };
                        return [4 /*yield*/, projectApiClient.fetchProjects(params)];
                    case 1:
                        res = _c.sent();
                        _b = res.data, projects = _b.projects, paginate = _b.meta.paginate;
                        commit(ProjectMutationTypes.INIT_PROJECTS, { projects: projects, paginate: paginate });
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchProjects: function (_a) {
        var getters = _a.getters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var currentProjects, params, res, _b, projects, paginate;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentProjects = getters.projects;
                        params = { offset: currentProjects.length };
                        return [4 /*yield*/, projectApiClient.fetchProjects(params)];
                    case 1:
                        res = _c.sent();
                        _b = res.data, projects = _b.projects, paginate = _b.meta.paginate;
                        commit(ProjectMutationTypes.FETCH_PROJECTS, { projects: projects, paginate: paginate });
                        return [2 /*return*/];
                }
            });
        });
    },
    initListProjects: function (_a) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var sort, params, res, _b, projects, paginate;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sort = projectListSortKeyToApiSort(state.currentSort);
                        params = {
                            offset: 0,
                            limit: LIST_PROJECTS_PAGE_SIZE,
                            status: listFilterStatusToApiStatus(state.listFilterStatus),
                            sort: sort
                        };
                        if (state.listBookmarkedOnly) {
                            params.bookmarked = true;
                        }
                        return [4 /*yield*/, projectApiClient.fetchProjects(params)];
                    case 1:
                        res = _c.sent();
                        _b = res.data, projects = _b.projects, paginate = _b.meta.paginate;
                        commit(ProjectMutationTypes.INIT_LIST_PROJECTS, { projects: projects, paginate: paginate });
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchListProjects: function (_a) {
        var getters = _a.getters, commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var currentProjects, sort, params, res, _b, projects, paginate;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentProjects = getters.listProjects;
                        sort = projectListSortKeyToApiSort(state.currentSort);
                        params = {
                            offset: currentProjects.length,
                            limit: LIST_PROJECTS_PAGE_SIZE,
                            status: listFilterStatusToApiStatus(state.listFilterStatus),
                            sort: sort
                        };
                        if (state.listBookmarkedOnly) {
                            params.bookmarked = true;
                        }
                        return [4 /*yield*/, projectApiClient.fetchProjects(params)];
                    case 1:
                        res = _c.sent();
                        _b = res.data, projects = _b.projects, paginate = _b.meta.paginate;
                        commit(ProjectMutationTypes.FETCH_LIST_PROJECTS, { projects: projects, paginate: paginate });
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchProject: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.fetchProject(payload)];
                    case 1:
                        res = _b.sent();
                        commit(ProjectMutationTypes.FETCH_PROJECT, res.data.project);
                        dispatch('policy/fetchPolicies', res.data.meta.policies, {
                            root: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    createProject: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var file, coverImageName, res, canceller;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        file = payload.cover_image;
                        coverImageName = '';
                        payload.cover_image = '';
                        if (file) {
                            coverImageName = file.name;
                        }
                        return [4 /*yield*/, projectApiClient.createProject(Object.assign(payload, { cover_image_name: coverImageName }))];
                    case 1:
                        res = _b.sent();
                        canceller = CancelToken.source();
                        if (!(res.status === 200 && res.data.meta && file)) return [3 /*break*/, 3];
                        return [4 /*yield*/, projectApiClient.uploadFileS3Request(res.data.meta, file, {
                                cancelToken: canceller.token
                            })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (res.status === 200 && res.data.project) {
                            commit(ProjectMutationTypes.ADD_PROJECT, res.data.project);
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    },
    updateProject: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var id, params, file, coverImageName, res, canceller;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = payload.id, params = payload.params;
                        file = params.cover_image;
                        coverImageName = '';
                        params.cover_image = '';
                        if (file) {
                            coverImageName = file.name;
                        }
                        return [4 /*yield*/, projectApiClient.updateProject(id, Object.assign(params, { cover_image_name: coverImageName }))];
                    case 1:
                        res = _b.sent();
                        canceller = CancelToken.source();
                        if (!(res.status === 200 && res.data.meta && file)) return [3 /*break*/, 3];
                        return [4 /*yield*/, projectApiClient.uploadFileS3Request(res.data.meta, file, {
                                cancelToken: canceller.token
                            })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        commit(ProjectMutationTypes.FETCH_PROJECT, res.data.project);
                        return [2 /*return*/];
                }
            });
        });
    },
    updateProjectPeriod: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var id, params, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = payload.id, params = payload.params;
                        return [4 /*yield*/, projectApiClient.updateProjectPeriod(id, params)];
                    case 1:
                        res = _b.sent();
                        commit(ProjectMutationTypes.FETCH_PROJECT, res.data.project);
                        return [2 /*return*/];
                }
            });
        });
    },
    // 作成・更新時はフロントソート処理を行い現在の一覧を保持します
    deleteProject: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.deleteProject(payload)];
                    case 1:
                        _b.sent();
                        commit(ProjectMutationTypes.DELETE_PROJECT, payload);
                        dispatch('fetchBookmarks');
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchPlaces: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.fetchPlaces(payload)];
                    case 1:
                        res = _b.sent();
                        commit(ProjectMutationTypes.FETCH_PLACES, res.data);
                        return [2 /*return*/];
                }
            });
        });
    },
    clearPlaces: function (_a) {
        var commit = _a.commit;
        commit(ProjectMutationTypes.CLEAR_PLACES);
    },
    createInvitationLink: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectUserApiClient.createInvitationLink(payload)];
                    case 1:
                        res = _b.sent();
                        return [4 /*yield*/, navigator.clipboard.writeText(res.data.invitation_link)];
                    case 2:
                        _b.sent();
                        commit(ProjectMutationTypes.CREATE_INVITATION_LINK, res.data);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteInvitationLink: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectUserApiClient.deleteIvitationLink(payload)];
                    case 1:
                        _b.sent();
                        commit(ProjectMutationTypes.DELETE_INVITATION_LINK);
                        return [2 /*return*/];
                }
            });
        });
    },
    changeStatus: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var project, oldStatus, newStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        project = payload.project, oldStatus = payload.oldStatus, newStatus = payload.newStatus;
                        return [4 /*yield*/, projectApiClient.updateStatus(project.id, newStatus)];
                    case 1:
                        _b.sent();
                        commit(ProjectMutationTypes.CHANGE_STATUS, { id: project.id, status: newStatus });
                        if (newStatus === ProjectStatus.completed ||
                            oldStatus === ProjectStatus.completed ||
                            project.status === ProjectStatus.completed ||
                            newStatus === ProjectStatus.archived ||
                            oldStatus === ProjectStatus.archived ||
                            project.status === ProjectStatus.archived) {
                            dispatch('clearHierarchyCache');
                            dispatch('fetchHierarchyYearSummary');
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    createBookmark: function (_a, payload) {
        var dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.createBookmark({ project_id: payload })];
                    case 1:
                        _b.sent();
                        dispatch('fetchBookmarks');
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchBookmarks: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var project_bookmarks;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.fetchBookmarkIds()];
                    case 1:
                        project_bookmarks = (_b.sent()).data.project_bookmarks;
                        commit(ProjectMutationTypes.FETCH_BOOKMARKS, project_bookmarks);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteBookmark: function (_a, payload) {
        var dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.deleteBookmark(payload)];
                    case 1:
                        _b.sent();
                        dispatch('fetchBookmarks');
                        return [2 /*return*/];
                }
            });
        });
    },
    sortBookmarks: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var newIndex = _b.newIndex, oldIndex = _b.oldIndex;
        return __awaiter(this, void 0, void 0, function () {
            var id, project_bookmark;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        id = state.bookmarks[oldIndex].id;
                        return [4 /*yield*/, projectApiClient.updateBookmark({ id: id, sort_num: newIndex + 1 })];
                    case 1:
                        project_bookmark = (_c.sent()).data.project_bookmark;
                        commit(ProjectMutationTypes.SORT_BOOKMARKS, project_bookmark);
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchHierarchyYearSummary: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var res, yearSummary, meta;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, projectApiClient.fetchProjectAggregations({
                            status: ['completed', 'archived'],
                            group_by: ['year'],
                            include_meta: true
                        })];
                    case 1:
                        res = _b.sent();
                        yearSummary = res.data.aggregations;
                        meta = res.data.meta;
                        if (meta) {
                            commit(ProjectMutationTypes.SET_HIERARCHY_YEAR_SUMMARY, {
                                summary: yearSummary,
                                meta: { total_count: meta.total_count, unscheduled_count: meta.unscheduled_count }
                            });
                        }
                        else {
                            commit(ProjectMutationTypes.SET_HIERARCHY_YEAR_SUMMARY, yearSummary);
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchHierarchyUnscheduledProjects: function (_a, offset) {
        var commit = _a.commit, getters = _a.getters;
        if (offset === void 0) { offset = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var cached, res, projects, paginate;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cached = getters.hierarchyUnscheduledProjects;
                        if (cached.length > 0 && offset === 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, projectApiClient.fetchProjectsUnscheduled({
                                status: ['completed', 'archived'],
                                offset: offset,
                                limit: 100
                            })];
                    case 1:
                        res = _b.sent();
                        projects = res.data.projects;
                        paginate = res.data.meta.paginate;
                        if (offset === 0) {
                            commit(ProjectMutationTypes.SET_HIERARCHY_UNSCHEDULED_PROJECTS, { projects: projects, paginate: paginate });
                        }
                        else {
                            commit(ProjectMutationTypes.APPEND_HIERARCHY_UNSCHEDULED_PROJECTS, { projects: projects, paginate: paginate });
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchHierarchyMonthSummary: function (_a, year) {
        var commit = _a.commit, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var cached, from, to, res, monthSummary;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cached = getters.hierarchyMonthSummary(year);
                        if (cached)
                            return [2 /*return*/];
                        from = year + "-01-01";
                        to = year + "-12-31";
                        return [4 /*yield*/, projectApiClient.fetchProjectAggregations({
                                status: ['completed', 'archived'],
                                group_by: ['month'],
                                from: from,
                                to: to
                            })];
                    case 1:
                        res = _b.sent();
                        monthSummary = res.data.aggregations;
                        commit(ProjectMutationTypes.SET_HIERARCHY_MONTH_SUMMARY, {
                            year: year,
                            summary: monthSummary
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchHierarchyProjects: function (_a, _b) {
        var commit = _a.commit, getters = _a.getters;
        var year = _b.year, month = _b.month, _c = _b.offset, offset = _c === void 0 ? 0 : _c;
        return __awaiter(this, void 0, void 0, function () {
            var cached, endDateFrom, endDateTo, end_date_from, end_date_to, res, projects, paginate;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        cached = getters.hierarchyProjects(year, month);
                        if (cached && offset === 0)
                            return [2 /*return*/];
                        endDateFrom = new Date(year, month - 1, 1);
                        endDateTo = new Date(year, month, 0) // 月の最終日
                        ;
                        end_date_from = formatDateToISO(endDateFrom);
                        end_date_to = formatDateToISO(endDateTo);
                        return [4 /*yield*/, projectApiClient.fetchProjectsByDateRange({
                                status: ['completed', 'archived'],
                                end_date_from: end_date_from,
                                end_date_to: end_date_to,
                                offset: offset,
                                limit: 100
                            })];
                    case 1:
                        res = _d.sent();
                        projects = res.data.projects;
                        paginate = res.data.meta.paginate;
                        if (offset === 0) {
                            commit(ProjectMutationTypes.SET_HIERARCHY_PROJECTS, {
                                year: year,
                                month: month,
                                projects: projects,
                                paginate: paginate
                            });
                        }
                        else {
                            commit(ProjectMutationTypes.APPEND_HIERARCHY_PROJECTS, {
                                year: year,
                                month: month,
                                projects: projects,
                                paginate: paginate
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    clearHierarchyCache: function (_a) {
        var commit = _a.commit;
        commit(ProjectMutationTypes.CLEAR_HIERARCHY_CACHE);
    }
};
function formatDateToISO(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + "-" + month + "-" + day;
}
